/*
 * The measurement point tab keys, in their own module so pure-logic tests (tabActivationUtil) can
 * import the real enum. Importing it from Mobile/Measurements drags in RequestPartContainer, the
 * redux tree and MsalInstance, which constructs a PublicClientApplication at module load and throws
 * BrowserAuthError: crypto not available under jsdom.
 */
export enum TabType {
    Default = 0,
    Photos = 'photos',
    Parts = 'parts',
    DamageCodes = 'damageCodes',
    Repairs = 'repairs',
    More = 'more'
}
